import { cls } from "app/utils";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

export type AcademyPlanCode = "coachacademy+monthly" | "coachacademy+yearly";

interface PricingToggleProps {
  planCode: AcademyPlanCode;
  onPlanSelect: (planCode: AcademyPlanCode) => void;
  lockedPlan?: AcademyPlanCode;
  discount?: string;
  // When given, only these terms can be picked: a re-price offers the terms
  // the subscription may move to.
  availablePlans?: AcademyPlanCode[];
}

const PricingToggle: React.FC<PricingToggleProps> = ({
  planCode,
  onPlanSelect,
  lockedPlan,
  discount,
  availablePlans,
}) => {
  const { t } = useTranslation();
  // A promo can lock the term (ACADEMYGGNASDY is yearly-only, ACADEMYGGNASDM monthly-only);
  // the non-matching term is then disabled.
  const unavailable = (code: AcademyPlanCode) =>
    availablePlans != null && !availablePlans.includes(code);
  const yearlyDisabled =
    (lockedPlan != null && lockedPlan !== "coachacademy+yearly") ||
    unavailable("coachacademy+yearly");
  const monthlyDisabled =
    (lockedPlan != null && lockedPlan !== "coachacademy+monthly") ||
    unavailable("coachacademy+monthly");

  return (
    <div className={styles.toggle_container}>
      <button
        className={cls(styles.toggle_button, {
          [styles.active]: planCode === "coachacademy+yearly",
          [styles.disabled]: yearlyDisabled,
        })}
        disabled={yearlyDisabled}
        onClick={() => onPlanSelect("coachacademy+yearly")}
      >
        {t("Annual")}
        {planCode === "coachacademy+yearly" && discount && (
          <span className={styles.discount_badge}>{discount}</span>
        )}
      </button>
      <button
        className={cls(styles.toggle_button, {
          [styles.active]: planCode === "coachacademy+monthly",
          [styles.disabled]: monthlyDisabled,
        })}
        disabled={monthlyDisabled}
        onClick={() => onPlanSelect("coachacademy+monthly")}
      >
        {t("Monthly")}
      </button>
    </div>
  );
};

export default PricingToggle;
